import React, { useEffect } from 'react';
import { Col, Button, Container, Form, Row } from 'reactstrap';
import * as poolActions from '../actions/pool';
import { useDispatch, useSelector } from 'react-redux';
import { poolLabel } from '../Components/Constants/static';
import { hasPrivilege } from '../Components/Utils/utils';
import AccessDenied from '../Components/Error/AccessDenied';
// import { PoolConfigure } from '../Components/Utils/PoolConfig';
const PoolConfigure = [
	{
		Label: 'DOORKEEPER',
		Pool: 'DOORKEEPER',
		Roles: 'DOORKEEPER'
	},
	{
		Label: 'REPOST-DEV',
		Pool: 'REPOST-DEV',
		Roles: 'REPOST-DEV'
	},
	{
		Label: 'TEST-APP',
		Pool: 'TEST-APP',
		Roles: 'TEST-APP'
	}
];
const Home = () => {
	const dispatch = useDispatch();
	const setUserPool = pool => {
		dispatch(poolActions.setUserPool(pool));
		dispatch(poolActions.setRoles(pool, roleAccess));
	};
	const { poolAccess, roleAccess, superAdmin } = useSelector(state => state.account);
	const { userPool } = useSelector(state => state.pool);
	let poolAccessLen = poolAccess && poolAccess.length;
	let gridUnits = {
		1: '12',
		2: '6',
		3: '4'
	};
	useEffect(() => {
		if (poolAccessLen === 1 && !superAdmin) {
			dispatch(poolActions.setUserPool(poolAccess[0]));
			dispatch(poolActions.setRoles(poolAccess[0], roleAccess));
		}
	}, [dispatch, poolAccessLen, poolAccess, roleAccess, superAdmin]);

	return (
		<>
			{!userPool && poolAccessLen === 0 && !superAdmin && (
				<>
					<AccessDenied />
				</>
			)}

			{!userPool && (superAdmin || poolAccessLen > 1) ? (
				<Container fluid>
					<div
						style={{
							textAlign: 'center',
							fontFamily: 'none',
							fontSize: '22px',
							paddingTop: '20px'
						}}
					>
						Please select the User pool
					</div>
					<div className='homeFormGroup'>
						{PoolConfigure.map((pool, index) => {
							const { Roles, Label, Pool } = pool;
							return (
								hasPrivilege(poolAccess, [Roles], superAdmin) && (
									<Button className='pool-alignment' onClick={() => setUserPool(Pool)} key={index}>
										{Label}
									</Button>
								)
							);
						})}
					</div>
				</Container>
			) : (
				<div className='user-pool-text'>{poolLabel[userPool]}</div>
			)}
		</>
	);
};

export default Home;
